import * as React from 'react';
import * as styles from './FolderName.css';
import { ELinkOpenMode } from '../../../types';
export function FolderName(_ref) {
  var folderUrl = _ref.folderUrl,
    _ref$linkOpenMode = _ref.linkOpenMode,
    linkOpenMode = _ref$linkOpenMode === void 0 ? ELinkOpenMode.Self : _ref$linkOpenMode,
    text = _ref.text,
    onClick = _ref.onClick;
  return folderUrl ? /*#__PURE__*/React.createElement("a", {
    href: folderUrl,
    className: styles['folder'],
    onClick: onClick,
    target: linkOpenMode
  }, text) : /*#__PURE__*/React.createElement("span", {
    className: styles['text']
  }, text);
}